import AbstractComponent from "./abstract-component";


const createTemplate = (className, isLikeMP, {itemId, title, link}) => {

  return (
    `<article class="${className}__item" data-like-mp="${isLikeMP}">
      <h3 class="${className}__itemTitle">
        <a class="" href="${link}">${title}</a>
      </h3>
      <a class="${className}__itemImage" href="${link}"></a>
      <div class="${className}__infoWrap">
        <span class="${className}__itemId">Код: ${itemId}</span>
      </div>
    </article>`
  );
};

export default class ProductCardTileComponent extends AbstractComponent {
  constructor({className = ``, isLikeMP = false, data = ``}) {
    super();

    this._className = className;
    this._isLikeMP = isLikeMP;
    this._data = data;
  }

  getTemplate() {
    return createTemplate(this._className, this._isLikeMP, this._data);
  }
}
